// import { useDispatch } from 'react-redux';
// import { toast } from 'react-toastify';
// import { FormInputNameContacts } from '@/features/core/auth/types';
// import validators from '@/helpers/validators';
// import useForm from '@/hooks/useForm';
// import ContactUs from '@/model/ContactUs';
// import { setLoading } from '@/redux/loading/loadingSlice';
// import { api } from '@/services/api';
// import { UseFormControl } from 'src/types';
import React from 'react';
import { ContactsContainer } from './ui';

export const ContactsScreen: React.FC = () => (
  //   const dispatch = useDispatch();

  //   const {
  //     formData: formDataContacts,
  //     formErrors: formErrorsContacts,
  //     setErrors: setErrorsContacts,
  //     onChangeFormInput: onChangeFormInputContacts,
  //     isFormValid: isFormValidContacts,
  //     resetForm: resetFormContacts,
  //   } = useForm({
  //     initialData: {
  //       name: '',
  //       email: '',
  //       message: '',
  //     },
  //     validators: {
  //       name: [validators.required],
  //       email: [validators.required, validators.email],
  //       message: [validators.required],
  //     },
  //     formatters: {},
  //   });

  //   const handleSubmitContact = async (): Promise<void> => {
  //     if (isFormValidContacts()) {
  //       try {
  //         dispatch(setLoading(true));
  //         const contactUs: ContactUs = {
  //           name: formDataContacts[FormInputNameContacts.name],
  //           email: formDataContacts[FormInputNameContacts.email],
  //           message: formDataContacts[FormInputNameContacts.message],
  //         };
  //         await api.post('/auth/contact-us', contactUs);
  //         resetFormContacts();
  //         dispatch(setLoading(false));
  //         toast.success('Mensagem enviada com sucesso!');
  //       } catch (error) {
  //         dispatch(setLoading(false));
  //       }
  //     }
  //   };

  //   const controllerContacts: UseFormControl = {
  //     formData: formDataContacts,
  //     formErrors: formErrorsContacts,
  //     setErrors: setErrorsContacts,
  //     onChangeFormInput: onChangeFormInputContacts,
  //     isFormValid: isFormValidContacts,
  //     resetForm: resetFormContacts,
  //   };
  <>
    <ContactsContainer
    // controllerContacts={controllerContacts}
    // onSubmit={handleSubmitContact}
    />
  </>
);
